import { formatNumberToPriceText } from '@/lib/utils';
import { Basket } from '@/models/Basket';

export interface DeliveryFeeHint {
  remaining: number;
  fee: number;
  free: boolean;
  text: string;
}

export function getDeliveryFeeHints(basket?: Basket): DeliveryFeeHint[] {
  const coverageType = basket?.deliveryTime?.coverageType;
  const limits = coverageType?.deliveryFeeLimits;

  if (!coverageType || !Array.isArray(limits) || limits.length === 0) {
    return [];
  }

  // `total` müşteriden tahsil edilen tutardır (ürünler + teslimat). Limit eşikleri
  // ürün tutarına (itemsTotal) göre değerlendirilir.
  const itemsTotal = (basket?.total ?? 0) - (basket?.deliveryFee ?? 0);
  const currentFee = basket?.deliveryFee ?? coverageType.deliveryFee ?? 0;

  return limits
    .filter(
      (limit) => (limit?.minimumAmount ?? 0) > itemsTotal && (limit?.deliveryFee ?? 0) < currentFee,
    )
    .sort((a, b) => (a.minimumAmount ?? 0) - (b.minimumAmount ?? 0))
    .map((limit) => {
      const remaining = Math.round(((limit.minimumAmount ?? 0) - itemsTotal) * 100) / 100;
      const fee = limit.deliveryFee ?? 0;
      const free = fee <= 0;
      const text = free
        ? `${formatNumberToPriceText(remaining)} TL daha harca, teslimat ücretsiz olsun!`
        : `${formatNumberToPriceText(remaining)} TL daha harca, teslimat ücreti ${formatNumberToPriceText(fee)} TL'ye düşsün!`;

      return { remaining, fee, free, text };
    });
}

export default function DeliveryFeeHints({
  basket,
  className,
}: {
  basket?: Basket;
  className?: string;
}) {
  const hints = getDeliveryFeeHints(basket);

  // Sadece en yakın hedefi göster (remaining en küçük olan).
  const hint = hints[0];

  if (!hint) {
    return null;
  }

  const highlight = 'text-red-600 font-bold';

  return (
    <div className={className ?? ''}>
      <p className="text-sm text-black">
        <span className={highlight}>{formatNumberToPriceText(hint.remaining)} TL</span>
        {hint.free ? (
          <>
            {' daha harca, teslimat '}
            <span className={highlight}>ücretsiz</span>
            {' olsun!'}
          </>
        ) : (
          <>
            {' daha harca, teslimat ücreti '}
            <span className={highlight}>{formatNumberToPriceText(hint.fee)} TL</span>
            {"'ye düşsün!"}
          </>
        )}
      </p>
    </div>
  );
}
